'use strict';

import GenogramItem from "@shared/Genogram/GenogramItem";
import {decodeGenogramJsonBase64, encodeGenogramJsonBase64} from "@/tools/GenogramTool/lib/genogramCodec";

function buildGenogramJsonData(genogramData) {
	let nodes = genogramData.filter(item => !item.data?.source && !item.data?.target)
	let edges = genogramData.filter(item => item.data?.source && item.data?.target)
	let jsonData = {
		...getDefaultGenogramJsonData(),
		elements: {nodes, edges},
	}
	return jsonData
}

function getDefaultGenogramJsonData() {
	return {
		elements: {nodes: [], edges: []},
		pan: {x: 0, y: 0},
		panningEnabled: true,
		userPanningEnabled: true,
		userZoomingEnabled: true,
		zoom: 1,
		zoomingEnabled: true,
	}
}

function createGenogramItemFromJson(genogramJson, clientId) {
	let genogramItem = new GenogramItem(clientId)
	let jsonData = genogramJson?.jsonData || genogramJson || {}
	if (genogramJson?.jsonData) {
		Object.assign(genogramItem, genogramJson)
	}
	genogramItem.setClientId(clientId || genogramItem.clientId)
	genogramItem.jsonData = {
		...getDefaultGenogramJsonData(),
		...jsonData,
	}
	genogramItem.updateNodeLabelAll()
	return genogramItem
}

function buildGenogramInputFromItem(genogramItem) {
	return {
		type: "genogramJson",
		value: sanitizeGenogramItemForInput(genogramItem),
	}
}

function buildGenogramBase64InputFromItem(genogramItem) {
	let value = encodeGenogramJsonBase64(sanitizeGenogramItemForInput(genogramItem))
	return {
		type: "genogramJsonBase64",
		value,
	}
}

function sanitizeGenogramItemForInput(genogramItem) {
	let sanitizedItem = JSON.parse(JSON.stringify(genogramItem || {}))
	let elements = sanitizedItem?.jsonData?.elements || {}

	sanitizeElementSelections(elements.nodes)
	sanitizeElementSelections(elements.edges)

	return sanitizedItem
}

function sanitizeElementSelections(elements = []) {
	if (!Array.isArray(elements)) {
		return
	}

	elements.forEach((element) => {
		if ("selected" in element) {
			element.selected = false
		}
	})
}

async function createGenogramItemFromCommands(instructions, clientId) {
	const { default: GenogramLayoutManager } = await import("@/tools/GenogramTool/GenogramLayoutManager");
	let genogramLayoutManager = new GenogramLayoutManager()
	let elementsLayout = genogramLayoutManager.layoutFamilyTree({instructions})
	let {genogramData} = genogramLayoutManager.familyTreeToGenogramData(elementsLayout)

	let genogramItem = new GenogramItem(clientId)
	genogramItem.jsonData = buildGenogramJsonData(genogramData)
	genogramItem.updateNodeLabelAll()
	return genogramItem
}

async function createGenogramItemFromInput(input, clientId) {
	let genogramItem = null
	let inputType = input?.type
	let inputValue = input?.value

	if (inputType === "genogramJson") {
		genogramItem = createGenogramItemFromJson(inputValue, clientId)
	}
	if (!genogramItem && inputType === "genogramJsonBase64" && typeof inputValue === "string") {
		let decodedValue = decodeGenogramJsonBase64(inputValue)
		genogramItem = createGenogramItemFromJson(decodedValue, clientId)
	}
	if (!genogramItem && (inputType === "commands" || inputType === "instructions") && Array.isArray(inputValue)) {
		genogramItem = await createGenogramItemFromCommands(inputValue, clientId)
	}

	return genogramItem
}

export {
	buildGenogramBase64InputFromItem,
	buildGenogramInputFromItem,
	buildGenogramJsonData,
	createGenogramItemFromCommands,
	createGenogramItemFromInput,
	createGenogramItemFromJson,
	getDefaultGenogramJsonData,
}
